import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, Divider, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Gene } from "../../../api/smartmelts-api/graphql/generated";

const useStyles = makeStyles((theme: Theme) => ({
  cell: {
    width: "25%",
    justifyContent: "center",
  },
  table: {
    overflowY: "auto",
  },
}));

const GeneTableCell: FunctionComponent = (props) => {
  const { children } = props;
  const classes = useStyles();
  return (
    <Grid item className={classes.cell}>
      <Typography align="center">{children}</Typography>
    </Grid>
  );
};

interface IGeneTableRow {
  gene: Gene;
}

const GeneTableRow: FunctionComponent<IGeneTableRow> = (props) => {
  const { gene } = props;
  return (
    <Grid container item>
      <GeneTableCell>{gene.orientation || "-"}</GeneTableCell>
      <GeneTableCell>{gene.name || "-"}</GeneTableCell>
      <GeneTableCell>{gene.refsnp || "-"}</GeneTableCell>
      <GeneTableCell>{gene.genotype || "-"}</GeneTableCell>
    </Grid>
  );
};

interface IGeneTableProps {
  genes: Gene[];
}
export const GeneTable: FunctionComponent<IGeneTableProps> = (props) => {
  const { genes } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container direction="column" className={classes.table}>
      <Grid container item>
        <GeneTableCell>{t("gene.orientation")}</GeneTableCell>
        <GeneTableCell>{t("gene.name")}</GeneTableCell>
        <GeneTableCell>{t("gene.refsnp")}</GeneTableCell>
        <GeneTableCell>{t("gene.genotype")}</GeneTableCell>
      </Grid>
      <Grid item>
        <Divider />
      </Grid>
      {genes.map((gene) => (
        <GeneTableRow key={gene.id} gene={gene} />
      ))}
    </Grid>
  );
};
